<script>
  import Card from "../../../../../components/layout/Card.svelte";
  import SettingIconButton from "../../../../../components/IconButtons/SettingIconButton.svelte";
  import OpenInNewIconButton from "../../../../../components/IconButtons/OpenInNewIconButton.svelte";
  import { getAutoMpsProjectContext } from "../../../../AutoMpsProjectContext.js";

  export let title

  export let isOpen = false

  /**
   * @type {string}
   */
  export let selectedImportId

  /**
   * @type {string}
   */
  export let dataType

  const ctx = getAutoMpsProjectContext()
</script>

<Card>
  <span style="display: inline-flex; justify-content: space-between; align-items: center">
    <span style="font-size: 1.1rem; font-weight: bold;">{title}</span>
    <span style="display: flex; align-items: center; gap: 1rem;">
      <a href="/auto-mps/projects/{$ctx.projectId}/imports/{dataType}/{selectedImportId}" target="_blank">
        <OpenInNewIconButton/>
      </a>
      <SettingIconButton onClick={() => isOpen = !isOpen} />
    </span>
  </span>
  <slot />
  {#if isOpen}
    <slot name="open" />
  {:else}
    <slot name="closed" />
  {/if}
</Card>
